import { AccountData } from "./AccountData";

export class AccountSelection {
   groupName: string;
   groupIdent: string;
   accountData: AccountData[];
   isDisabled: boolean;
}
